import { Tipo } from "./Tipo";
import { required } from "vuelidate/lib/validators";

class Cnae extends Tipo {
  constructor() {
    super();
    this.cnae = "";
  }
}

const CnaeValidation = {
  cnae: {
    required,
  },
};

export { Cnae, CnaeValidation };
